import '../assets/js/pace';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpModule } from '@angular/http';

import { AgmCoreModule } from '@agm/core';

import { routing } from './app.routing';
import { AppConfig } from './app.config';

import { AppComponent } from './app.component';
import { ErrorComponent } from './pages/error/error.component';
import { ToastrModule } from 'ngx-toastr';
import { TreeviewModule } from "ngx-treeview";
import { Ng2Webstorage } from "ngx-webstorage";
import { TagInputModule } from 'ngx-chips';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { DndModule } from 'ng2-dnd';

import { ConfiguracionSistemaService } from '../services/configuracion.sistema.service';

@NgModule({
  declarations: [
    AppComponent,
    ErrorComponent,
  ],
  imports: [
    TagInputModule,
    BrowserModule,
    BrowserAnimationsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDe_oVpi9eRSN99G4o6TwVjJbFBNr58NxE'
    }),
    routing,
    HttpModule,
    ToastrModule.forRoot(),
    TreeviewModule.forRoot(),
    DndModule.forRoot(),
  ],
  providers: [AppConfig, 
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    ConfiguracionSistemaService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Synergy/Projects/SFE/Synergy.UI/src/app/app.module.ts